<!-- SLIDE CART - ADA compliance - set focus -->

  /*window.SLIDECART_OPENED = function() {
    // Fires whenever Slide Cart has been opened
    //console.log("slidecart opened");
    var slidecart_heading = document.querySelector("div#slidecarthq div.slidecarthq header.header h2");
    if (slidecart_heading) {
      slidecart_heading.tabIndex = -1;
      slidecart_heading.focus();
      
    }
    //set quantity input label 
    var slidecart_qty = document.querySelectorAll("div#slidecarthq div.slidecarthq div.quantity-selector input");
    slidecart_qty.forEach((elem) => {
      elem.setAttribute("aria-label", "Quantity");
    });
    
  }*/

<!-- End Slide Cart - ADA compliance -->
  


    //jquery
    jQuery( document ).ready(function() {
      //console.log("Jquery document ready found...");
      // *** header search button - ADA compliance
      $(".header-search-btn").on("click", function() {
        $("#search-details").attr("open", true);
        console.log("search box found? ", $("input#Search-desktop").length);
        $("input#Search-desktop").focus();
      });
      //onClick="document.querySelector('#search-details').setAttribute('open', true); setTimeout(() => document.querySelector('input#Search-desktop').focus(), 2000)"
      
      // *** end header search button - ADA compliance
      
      // *** GiftShip - ADA compliance - set focus ***
      /*$("div#gsGroups").on("focus", ".gs__validate-line input.gs__search-input", function(){
        console.log("in focus - element: ", $(this));
        updateGiftShipFields($(this));
      });
      */
      //disable tabbing to boxes within the add line wrapper
      if (window.timerADA) clearInterval(window.timerADA);
      window.timerADA = setInterval(function() {
          if ($('.gs__add-line-wrapper input.gs__search-input').length) {
            if ($(".deweysADA").length === 0) {
              //add id so we don't process it again
              $("button.gs__add-shipping-address").addClass("deweysADA");
              $("button.gs__add-shipping-address").attr("tabindex", "0");
              $(".gs__add-line-wrapper input.gs__search-input").disabled = true;
              $(".gs__add-line-wrapper input.gs__search-input").attr("tabindex", "-1");
              $(".gs__add-line-wrapper .gs__cart-remove").attr("tabindex", "-1");
              //don't clear interval - if a row is added or deleted, we need to reprocess these elements
              //clearInterval(window.timerADA);
            }
          }
      }, 500);
      // *** End GiftShip - ADA compliance  ***

      // *** Restock Alerts - ADA compliance ***
      if ($(".block-product").length) {
        //this is a product page
        // look for restock alert button (loaded async)
        $(".block-product").on("click", ".restock-alerts-notify-button", function(){
          console.log("clicked restock alert button");
          //wait for modal to be created
          if (window.timerRestock) clearInterval(window.timerRestock);
          window.timerRestock = setInterval(function() {
            if ($(".restock-alerts-form-title").length) {
             
              console.log("form title: ", $(".restock-alerts-form-title").length);
              $(".restock-alerts-form-title").attr("tabindex", "-1");
              $(".restock-alerts-form-title").focus();
              $(".restock-alerts-email-input").attr("tabindex", "0");
              $(".restock-alerts-submit-button").attr("tabindex", "0");
              $(".restock-alerts-modal-close-btn").attr("tabindex", "0");
              clearInterval(window.timerRestock);
            }
          }, 100);
          
        });
        // *** End Restock Alerts - ADA compliance ***
        
        // *** Rise.ai gift card - ADA compliance
        $(".gwbutton").on("keyup", function(event) {
          if (event.keyCode === 13) {
            event.preventDefault();
            event.target.click();
            var iframe = $('.Rise-popup > iframe');
            if (iframe.length) {
              iframe[0].contentWindow.focus();
            }
          }
        });
        // *** End Rise.ai gift card - ADA compliance
      }

      // *** SlideCart overlay - why is there a "role=button"?
      /*if ($("#slidecarthq .slidecarthq-overlay").length) {
        console.log("slidecart overlay found");
        $(".slidecarthq-overlay").removeAttr("role");
      }
      */
      // *** end SlideCart overlay
      
      // *** Wufoo forms - handle submit button keydown
      //learn more form
      /*if ($("#wufoo-mg9yb721c0jwzz").length) {
        console.log("found div for wufoo: ");
        //wait for iframe to load 
        $('#wufooFormmg9yb721c0jwzz').load(function(){ 
          console.log("found iframe for wufoo: ");
          var iframe = $('#wufooFormmg9yb721c0jwzz').contents();
          console.log("iframe: ", iframe);
          console.log("#saveForm: ",  iframe.find("#saveForm"));
          console.log("input.submit: ",  iframe.find("input.submit"));
          iframe.find("#saveForm").on("keyup", function (event) {
              console.log("in savebutton keyup");
              if (event.keyCode === 13) {
                event.preventDefault();
                event.target.trigger( "mousedown" );
              }
          });
        });
      }
      */
      // *** End Wufoo forms - handle submit button keydown
    });
            
    
    
<!-- GiftShip - ADA compliance - set focus -->    
    function updateGiftShipFields(element) {
      //$("div.gs__address-wrapper div.gs__dropdown").addClass("active");
      var parent = element.parent();
      parent.addClass("active");
      
      //children divs 
      parent.find("div.item" ).each(function(index, element) {
        console.log( "in children", $( this ) );
        $(this).attr("tabindex", 0);
        $(this).attr("role", "button");
        $(this).off("keyup");//if already present
        $(this).on("keyup", function (event) {
          if (event.keyCode === 13) {
            event.preventDefault();
            event.target.click();
            //wait for modal 
            if (window.timerAddrModal) clearInterval(window.timerAddrModal);
            window.timerAddrModal = setInterval(function() {
              var gsmodal = $("div#gsModalContainer div.gs__modal-header h3");
              if (gsmodal.length) {
                //console.log("modal found - setting focus");
                gsmodal.attr("tabIndex", "-1");
                gsmodal.focus();
                clearInterval(window.timerAddrModal);
              }
            }, 100);
          }
        });
        //on last item, set up menu onBlur event 
        if (index === (parent.find("div.item" ).length-1)) {
          //close menu on blur 
          $(this).on("blur", function (event) {
            parent.removeClass("active");
        });
        }
      });
        
    }
    
 
<!-- End GiftShip - ADA compliance  -->
